import { h } from "omi";

import { IconProps } from "@/components";

export function GreenCheckCircleIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 32 32">
      <path d="M0 16C0 7.1634 7.1634 0 16 0s16 7.1634 16 16-7.1634 16-16 16S0 24.8366 0 16Z" fill="#DCFAE6" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m22.7953 9.8534-9.5466 9.2133-2.5334-2.7067c-.4666-.44-1.2-.4666-1.7333-.0933-.52.3867-.6667 1.0667-.3467 1.6133l3 4.88c.2934.4534.8.7334 1.3734.7334.5466 0 1.0666-.28 1.36-.7334.48-.6266 9.64-11.5466 9.64-11.5466 1.2-1.2267-.2534-2.3067-1.2134-1.3734v.0134Z"
        fill="#079455"
      />
    </svg>
  );
}
